import React from 'react';

import { Row, RowControlCell, RowHelp, RowLabel, RowLabelCell } from './styles';

interface SettingRowProps {
  label: string;
  help?: string;
  htmlFor?: string;
  children: React.ReactNode;
}

const SettingRow: React.FC<SettingRowProps> = ({ label, help, htmlFor, children }) => (
  <Row>
    <RowLabelCell>
      <RowLabel as={htmlFor ? 'label' : 'div'} htmlFor={htmlFor}>
        {label}
      </RowLabel>
      {help && <RowHelp>{help}</RowHelp>}
    </RowLabelCell>
    <RowControlCell>{children}</RowControlCell>
  </Row>
);

export default SettingRow;
